import useTranslation from "../CustomHooks/useTranslation";
import Image from "../images/Image";
import { emptyScreenContent } from "./EmptyScreenContent";

interface EmptyListingScreenProps {
  emptyScreenText: {
    heading1: string;
    heading2?: string;
    img?: string;
  };
  imageHight?: string;
}

export default function EmptyListingScreen({
  emptyScreenText,
  imageHight
}: EmptyListingScreenProps) {
  const { translate } = useTranslation(emptyScreenContent);
  return (
    <div className="flex flex-col items-center justify-center p-4 h-12 ">
      {/* Image container */}
      <Image 
        src={emptyScreenText.img || "empty_screen_img"} 
        className={`${imageHight} w-fit object-cover`}
        testId="empty-screen-image"
      />
      {/* Heading */}
      <h1 className="text-heading3 text-primary_text text-center pt-5 pb-1 text-base sm:text-lg md:text-xl lg:text-2xl">
        {translate(emptyScreenText.heading1)}
      </h1>
      {/* Subheading */}
     {emptyScreenText.heading2 && <p className="text-secondary_text text-body2 text-center text-sm sm:text-base md:text-lg">
        {translate(emptyScreenText.heading2)}
      </p>}
    </div>
  );
}
